export default "__VITE_ASSET__Bd42N$55__"